// extracted by mini-css-extract-plugin
export default {"root":"LoadMore_root__ey9kk"};